module.exports = __webpack_public_path__ + "static/img/tutorial_scan_qrcode@2x.98fcf3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FPS/tutorial_scan_qrcode@2x.png
// module id = pIhB
// module chunks = 1